import { IUserInfo } from '../Store/User/Types';
import { UserRights } from '../Store/UserManagement/Types';
import { PaletteMode } from '../Themes';

//const deserializeBoolean = (value: string) => value === 'true';
const deserializeString = (value: string) => value;
const deserializeNumber = (value: string) => Number.parseFloat(value);
const deserializeObjectState = (value: string) => {
	return JSON.parse(value);
};
const deserializePaletteMode = (value: string) => value as PaletteMode;

//const serializeBoolean = (value: boolean) => value ? 'true' : 'false';
const serializeString = (value: string) => value;
const serializeNumber = (value: number) => value.toString();
const serializeObjectState = (value: object | null) => JSON.stringify(value);
const serializePaletteMode = (value: PaletteMode) => value as string;

export interface IKeyValueStorage {
	locale: string;
	groupID: number;
	userDate: number;
	userInfo: IUserInfo;
	userName: string;
	userToken: string;
	userManagementRights: UserRights;
	theme: PaletteMode;
}

const keyValueStorageDeserializers: {
	[key in KeyValueStorageKey]: (value: string) => IKeyValueStorage[key];
} = {
	locale: deserializeString,
	groupID: deserializeNumber,
	userDate: deserializeNumber,
	userInfo: deserializeObjectState,
	userName: deserializeString,
	userToken: deserializeString,
	userManagementRights: deserializeObjectState,
	theme: deserializePaletteMode,
};

const keyValueStorageSerializers: {
	[key in KeyValueStorageKey]: (value: IKeyValueStorage[key]) => string;
} = {
	locale: serializeString,
	groupID: serializeNumber,
	userDate: serializeNumber,
	userInfo: serializeObjectState,
	userName: serializeString,
	userToken: serializeString,
	userManagementRights: serializeObjectState,
	theme: serializePaletteMode,
};

export type KeyValueStorageKey = keyof IKeyValueStorage;

export interface IUserStorage {
	del<T extends KeyValueStorageKey>(key: T): void;
	get<T extends KeyValueStorageKey>(
		key: T,
		defaultValue: IKeyValueStorage[T]
	): IKeyValueStorage[T];
	reset(): void;
	set<T extends KeyValueStorageKey>(key: T, value: IKeyValueStorage[T]): void;
}

export const TypedStorage: IUserStorage = {
	del: (key) => {
		localStorage.removeItem(key);
	},
	get: (key, defaultValue) => {
		const serialized = window.localStorage.getItem(key);

		if (serialized !== null) {
			return keyValueStorageDeserializers[key](serialized) as any;
		}
		return defaultValue;
	},
	reset: () => {
		localStorage.clear();
	},
	set: (key, value) => {
		const serializer = keyValueStorageSerializers[key] as (
			t: any
		) => string;
		localStorage.setItem(key, serializer(value));
	},
};
